import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService, LoaderState } from './loader.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

@Component({
    selector: 'ngx-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [CommonModule, MatProgressSpinnerModule],
})
export class LoaderComponent implements OnInit {
    loading = false;
    private subscription: Subscription;
    isDarkTheme = false;


    private checkRoute(): void {
        const currentRoute = this.router.url;
        this.isDarkTheme = currentRoute.startsWith('/kite');
    }

    constructor(loaderService: LoaderService,
        private router: Router,
    ) {
        this.subscription = loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.loading = state.show;
            });
    }

    ngOnInit(): void {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.checkRoute();
        });
        this.checkRoute();
    }

}
